import React, { Component } from "react";

class PickupLoading extends Component {
	render() {
		return (
			<React.Fragment>
				<div className="pnwyq _12s3o">
                    <div className="_34fNe _1Xl7I">
                        <div className="_1uzET">
                            <button className="dwKwy" aria-label="double tap to go back" style={{backgroundColor: 'rgba(2, 6, 12, 0.15)'}}>
                            <svg className="_1Eaan TZUUl" width={20} height={20} viewBox="0 0 20 20" fill="none" aria-hidden="true" color="#FFFFFF">
                                <path fillRule="evenodd" clipRule="evenodd" d="M19.9004 9.99985C19.9004 10.4969 19.4974 10.8998 19.0004 10.8998L3.1733 10.8998L8.63679 16.3633C8.98826 16.7148 8.98826 17.2847 8.63679 17.6361C8.28532 17.9876 7.71547 17.9876 7.36399 17.6361L1.07122 11.3434C0.329227 10.6014 0.329227 9.39834 1.07122 8.65635L7.364 2.36358C7.71547 2.01211 8.28532 2.01211 8.63679 2.36358C8.98826 2.71505 8.98826 3.2849 8.63679 3.63637L3.17331 9.09985L19.0004 9.09985C19.4974 9.09985 19.9004 9.50279 19.9004 9.99985Z" fill="#FFFFFF" fillOpacity="0.92" />
                            </svg>
                            </button>
                        </div>
                        <div className="_3Xmsf">
                            <div className="kkFy2">
                                <div className="_3hPke" style={{width: '80px'}} />
                                <div className="_3hPke" style={{width: '158px', marginTop: '43px'}} />
                                <div className="_3hPke" style={{width: '186px', marginTop: '16px'}} />
                                <div className="_3hPke" style={{width: '96px', marginTop: '24px'}} />
                                <div className="_3bqmQ" />
                                <div className="_3y-l-">
                                    <div className="_2_Bsc _3dSmn" />
                                    <div className="_2_Bsc" />
                                    <div className="_2_Bsc" />
                                </div>
                            </div>
                            <div className="qqAo7">
                                <div className="_1T1Fk" />
                                <div className="_2CvlN">
                                    <div className="_3hPke _3LpOr" style={{width: '100%'}} />
                                    <div className="_3hPke _3LpOr" style={{width: '40%', marginTop: '16px'}} />
                                </div>
                            </div>
                            <div className="_1XguD">
                                <div className="_3hPke _3LpOr" style={{width: '70%'}} />
                                <div className="_3hPke _3LpOr" style={{width: '90%', marginTop: '32px'}} />
                                <div className="_3hPke _3LpOr" style={{width: '70%', marginTop: '20px'}} />
                                <div className="_3-3-S">
                                    <div className="_3hPke _3dSmn" style={{width: '65%', marginTop: '24px'}} />
                                    <div className="_3hPke _3dSmn" style={{width: '10%', marginTop: '24px'}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</React.Fragment>
		);
	}
}

export default PickupLoading;
